import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../lib/api";
import AdminLayout from "./AdminLayout";

export default function ProtectedAdmin() {
  const token = getToken();
  if (!token) return <Navigate to="/admin/login" replace />;
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
